<form class="createClientForm" [formGroup]="formGroup" (ngSubmit)="save()"
  (keydown)="onFormEnter($event)" novalidate>
  <div class="dialogHeader" mat-dialog-title>
    <div>
      <div class="dialogTitle">{{ title }}</div>
      <div class="dialogSubtitle">{{ subtitle }}</div>
    </div>
    <button mat-icon-button type="button" (click)="close()" [disabled]="saving || phoneActionLoading" aria-label="Закрыть" title="Закрыть">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="clientDialogContent">
    <div class="formGrid">
      <section class="formSection identitySection">
        <div class="sectionHeader">
          <span><mat-icon>person</mat-icon> Клиент</span>
        </div>

        <div class="sectionFields">
          <mat-form-field appearance="outline" class="span2">
            <mat-label>Имя или название</mat-label>
            <input formControlName="name" matInput />
            <button *ngIf="!isEditMode" mat-button matSuffix type="button"
              class="defaultNameButton" color="primary" [disabled]="saving"
              title="Подставить название «Клиент»" (click)="useDefaultName()">
              Имя не указано
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="span2" *ngIf="!isEditMode">
            <mat-label>Телефон</mat-label>
            <input formControlName="phone" mask="(000) 000 00 00" matInput />
            <mat-error *ngIf="phoneFormControl.invalid">Проверьте номер телефона</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="span2">
            <mat-label>Рейтинг</mat-label>
            <mat-select formControlName="rating">
              <mat-option [value]="0">Не указан</mat-option>
              <mat-option [value]="1">1</mat-option>
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="3">3</mat-option>
              <mat-option [value]="4">4</mat-option>
              <mat-option [value]="5">5</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <section class="formSection paymentSection">
        <div class="sectionHeader">
          <span><mat-icon>account_balance_wallet</mat-icon> Оплата и уведомления</span>
        </div>

        <div class="sectionFields">
          <div class="toggleRow span2">
            <mat-slide-toggle color="primary" formControlName="smsNotificationsEnabled">
              SMS уведомления
            </mat-slide-toggle>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Отсрочка, дней</mat-label>
            <input formControlName="paymentDelayDays" matInput type="number" min="0" step="1" />
            <mat-hint>Пусто - без проверки, 0 - день отгрузки</mat-hint>
            <mat-error *ngIf="paymentDelayDaysFormControl.invalid">Только целое число от 0</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Лимит долга, грн</mat-label>
            <input formControlName="debtLimit" matInput type="number" min="0" step="0.01" />
            <mat-hint>Пусто - без лимита</mat-hint>
            <mat-error *ngIf="debtLimitFormControl.invalid">Сумма не может быть меньше 0</mat-error>
          </mat-form-field>
        </div>
      </section>
    </div>

    <section class="formSection phonesSection" *ngIf="isEditMode">
      <div class="sectionHeader">
        <span><mat-icon>phone</mat-icon> Телефоны</span>
        <span class="sectionCounter">{{ phones.length }}</span>
      </div>

      <div class="phoneManagementGrid">
        <div class="phoneRows" *ngIf="phones.length > 0; else noPhones">
          <div class="phoneRow" *ngFor="let phone of phones">
            <ng-container *ngIf="editingPhoneId !== phone.id; else editPhoneTemplate">
              <div class="phoneData">
                <span>{{ formatPhone(phone.phone) }}</span>
                <small *ngIf="phone.isPrimary">Основной</small>
              </div>
              <div class="phoneActions">
                <button
                  mat-icon-button
                  *ngIf="!phone.isPrimary"
                  type="button"
                  (click)="makePrimary(phone.id)"
                  [disabled]="phoneActionLoading"
                  aria-label="Сделать основным" title="Сделать основным"
                >
                  <mat-icon>star</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="startEditPhone(phone)"
                  [disabled]="phoneActionLoading"
                  aria-label="Редактировать телефон" title="Редактировать телефон"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  type="button"
                  (click)="removePhone(phone.id)"
                  [disabled]="phoneActionLoading"
                  aria-label="Удалить телефон" title="Удалить телефон"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </ng-container>

            <ng-template #editPhoneTemplate>
              <div class="phoneEdit">
                <mat-form-field appearance="outline">
                  <mat-label>Телефон</mat-label>
                  <input matInput [formControl]="editPhoneFormControl" mask="(000) 000 00 00" />
                  <mat-error *ngIf="editPhoneFormControl.invalid">Проверьте номер</mat-error>
                </mat-form-field>
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  (click)="savePhone(phone.id)"
                  [disabled]="phoneActionLoading || editPhoneFormControl.invalid"
                >
                  Сохранить
                </button>
                <button mat-button type="button" (click)="cancelEditPhone()">Отмена</button>
              </div>
            </ng-template>
          </div>
        </div>

        <ng-template #noPhones>
          <div class="emptyState">Телефоны не добавлены</div>
        </ng-template>

        <div class="addPhonePanel">
          <div class="addPhoneRow">
            <mat-form-field appearance="outline">
              <mat-label>Новый телефон</mat-label>
              <input matInput [formControl]="addPhoneFormControl" mask="(000) 000 00 00" />
              <mat-error *ngIf="addPhoneFormControl.invalid">Проверьте номер</mat-error>
            </mat-form-field>
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="addPhone()"
              [disabled]="phoneActionLoading || addPhoneFormControl.invalid || !addPhoneFormControl.value"
            >
              Добавить
            </button>
          </div>
        </div>
      </div>
      <div class="phoneHint">Изменения телефонов сохраняются сразу.</div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialogActions">
    <button mat-button type="button" (click)="close()" [disabled]="saving || phoneActionLoading">Отмена</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="saving || phoneActionLoading || formGroup.invalid">
      {{ saving ? 'Сохранение...' : 'Сохранить' }}
    </button>
  </mat-dialog-actions>
</form>
